import type { BrebQrPayTranslations } from "../interfaces/brebQrPay";

export const brebQrPayTranslations: BrebQrPayTranslations = {
  scan_button: "Scan QR",
  scan_not_breb: "That code is not a Bre-B QR.",
  scan_image_no_qr: "We could not find a QR code in the image.",
  scan_image_failed: "We could not read the image. Try another one.",

  camera_title: "Scan the Bre-B QR",
  camera_hint: "Center the code inside the frame",
  camera_close: "Close camera",
  camera_starting: "Opening the camera…",
  camera_foreign_qr: "That code is not a Bre-B QR",
  camera_torch_on: "Flashlight",
  camera_torch_off: "Turn off flashlight",
  camera_upload: "Upload image",
  camera_retry: "Retry",
  camera_denied_title: "No permission to use the camera",
  camera_denied_text: "Allow camera access in your browser settings and retry, or upload an image of the QR.",
  camera_not_found: "We could not find a camera on this device. Upload an image of the QR.",
  camera_in_use: "Another app is using the camera. Close it and retry.",
  camera_insecure: "The camera only works over a secure connection (HTTPS).",
  camera_unsupported: "This browser cannot use the camera. Upload an image of the QR.",
  camera_error: "We could not open the camera.",

  resolving: "Checking the code…",
  resolve_invalid_title: "Invalid QR",
  resolve_invalid_text: "We could not read this code as a Bre-B QR. Scan it again or ask for another one.",
  resolve_key_not_found_title: "Invalid key",
  resolve_key_not_found_text: "The key in this QR does not exist or is inactive. Ask for a new code.",
  resolve_unavailable_title: "We could not check the code",
  resolve_unavailable_text: "Check your connection and try again.",
  resolve_access_denied_title: "No access",
  resolve_access_denied_text: "Your user is not allowed to view payments.",
  resolve_unsupported_title: "QR not supported",
  resolve_unsupported_text:
    "For now you cannot pay this QR from Coloca. Use another payment method at the store.",
  resolve_retry: "Retry",
  resolve_scan_another: "Scan another code",
  qr_clear: "Remove QR",

  payee_label: "You are paying",
  payee_merchant: "Business",
  payee_person: "Person",
  payee_bank: "Bank",
  payee_key: "Key",
  payee_document: "Document",
  payee_reference: "Reference",
  payee_inactive: "The key is not active (status: {{status}}). It cannot be paid.",

  amount_fixed_hint: "Set by the code and cannot be changed. The fee is added on top of it.",

  block_amount_mismatch: "This exact amount cannot be paid. Scan the code again.",
  resolve_not_enabled_title: "Pay with QR is not available",
  resolve_not_enabled_text: "For now your organization cannot pay QRs from Coloca.",
};
